import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import styles from '../table.module.css';

// This is a custom filter UI for selecting
// a unique option from a list
const MultiSelectColumnFilter = ( {
	column: {
		filterValue,
		preFilteredRows,
		id,
		setFilter,
		setTableState
	}
} ) => {
	// Calculate the options for filtering
	//  using the preFilteredRows
	const options = React.useMemo( () => {
		const options = new Set();

		preFilteredRows.forEach( row => {
			options.add( row.values[ id ] );
		} );

		return [ ...options.values() ];
	}, [ id, preFilteredRows ] );

	const mapOptions = () => options.map( ( option, i ) => ( {
		key: i + 1,
		text: option,
		value: option
	} ) );

	const handleChange = useCallback( ( e, { value } ) => {
		setTableState
			? setTableState( prev => {
				const filters = prev.filters?.length
					? prev.filters.filter( col => col.id !== id )
					: [];

				return {
					...prev,
					filters: value
						? [
							...filters,
							{ id, value }
						]
						: filters
				};
			} )
			: setFilter( value || [] );
	}, [
		id,
		setFilter,
		setTableState
	] );

	const renderLabel = ( { text } ) => ( {
		color: 'pink',
		content: `${ text }`
	} );

	const value = useMemo( () => filterValue || [], [ filterValue ] );

	// Render a multi-select box
	return (
		<>
			<Dropdown
				className={ styles.multiSelectFilter }
				// clearable
				closeOnChange
				fluid
				multiple
				onChange={ handleChange }
				options={ mapOptions() }
				renderLabel={ renderLabel }
				selection
				value={ value }
			/>
		</>
	);
};

MultiSelectColumnFilter.propTypes = {
	column: PropTypes.shape( {
		filterValue: PropTypes.array,
		preFilteredRows: PropTypes.array,
		setFilter: PropTypes.func,
		setTableState: PropTypes.func,
		id: PropTypes.string
	} )
};

export default memo( MultiSelectColumnFilter );
